// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emppeoplepage-inline-1 {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.emppeoplepage-inline-2 {
  flex: 1 1;
  min-width: 200px;
  position: relative;
}

.emppeoplepage-inline-3 {
  position: absolute;
  left: 10px;
  top: 10px;
  color: #94a3b8;
  width: 16px;
  height: 16px;
}

.emppeoplepage-inline-4 {
  padding-left: 32px;
}

.emppeoplepage-inline-5 {
  width: auto;
  min-width: 120px;
}

.emppeoplepage-inline-6 {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 12px;
}

.emppeoplepage-inline-7 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}

.emppeoplepage-inline-8 {
  cursor: pointer;
}

.emppeoplepage-inline-9 {
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.emppeoplepage-inline-10 {
  flex: 1 1;
  min-width: 0;
}

.emppeoplepage-inline-11 {
  font-weight: 700;
  font-size: 13px;
}

.emppeoplepage-inline-12 {
  font-size: 11px;
  color: #64748b;
}

.emppeoplepage-inline-13 {
  font-size: 10px;
  color: #94a3b8;
  font-family: monospace;
}

.emppeoplepage-inline-14 {
  text-align: center;
  padding: 40px;
}

.emppeoplepage-inline-15 {
  font-size: 32px;
  margin-bottom: 8px;
}

.emppeoplepage-inline-16 {
  font-weight: 600;
  margin-bottom: 4px;
}

.emppeoplepage-inline-17 {
  font-size: 12px;
  color: #94a3b8;
}

.emppeoplepage-inline-18 {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.emppeoplepage-inline-19 {
  font-weight: 700;
  font-size: 16px;
}

.emppeoplepage-inline-20 {
  font-size: 12px;
  color: #64748b;
}

.emppeoplepage-inline-21 {
  font-size: 11px;
  color: #94a3b8;
}

.emppeoplepage-inline-22 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 20px;
}

.emppeoplepage-inline-23 {
  margin-bottom: 4px;
}

.emppeoplepage-inline-24 {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.emppeoplepage-inline-25 {
  font-size: 13px;
  font-weight: 500;
}

.emppeoplepage-dyn-1 {
  font-size: 9px;
  padding: 3px 8px;
  border-radius: 10px;
  background: var(--emppeoplepage-1-background);
  color: var(--emppeoplepage-1-color);
  font-weight: 700;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpPeoplePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":[".emppeoplepage-inline-1 {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.emppeoplepage-inline-2 {\n  flex: 1;\n  min-width: 200px;\n  position: relative;\n}\n\n.emppeoplepage-inline-3 {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  color: #94a3b8;\n  width: 16px;\n  height: 16px;\n}\n\n.emppeoplepage-inline-4 {\n  padding-left: 32px;\n}\n\n.emppeoplepage-inline-5 {\n  width: auto;\n  min-width: 120px;\n}\n\n.emppeoplepage-inline-6 {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 12px;\n}\n\n.emppeoplepage-inline-7 {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 12px;\n}\n\n.emppeoplepage-inline-8 {\n  cursor: pointer;\n}\n\n.emppeoplepage-inline-9 {\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.emppeoplepage-inline-10 {\n  flex: 1;\n  min-width: 0;\n}\n\n.emppeoplepage-inline-11 {\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.emppeoplepage-inline-12 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.emppeoplepage-inline-13 {\n  font-size: 10px;\n  color: #94a3b8;\n  font-family: monospace;\n}\n\n.emppeoplepage-inline-14 {\n  text-align: center;\n  padding: 40px;\n}\n\n.emppeoplepage-inline-15 {\n  font-size: 32px;\n  margin-bottom: 8px;\n}\n\n.emppeoplepage-inline-16 {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.emppeoplepage-inline-17 {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.emppeoplepage-inline-18 {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.emppeoplepage-inline-19 {\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.emppeoplepage-inline-20 {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.emppeoplepage-inline-21 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.emppeoplepage-inline-22 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px 20px;\n}\n\n.emppeoplepage-inline-23 {\n  margin-bottom: 4px;\n}\n\n.emppeoplepage-inline-24 {\n  font-size: 10px;\n  color: #94a3b8;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.emppeoplepage-inline-25 {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.emppeoplepage-dyn-1 {\n  font-size: 9px;\n  padding: 3px 8px;\n  border-radius: 10px;\n  background: var(--emppeoplepage-1-background);\n  color: var(--emppeoplepage-1-color);\n  font-weight: 700;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
